<template>
  <VDialog
      class="products-picker-dialog content-block-style"
      position="right"
      width="1300px"
      height="100%"
      closable
      no-padding
  >
    <template #header>
      <span>Добавление продуктов в ЗТК</span>
    </template>

    <VDataGridV2
        :loader="dataLoader"
        sticky
        selectable
        paginated
        :skeleton-row-count="21"
        entity-type="productsPicker"
        :selected-rows="selectedDocuments"
        @row:selected="addDocument"
        @row:deselected="removeDocument"
    >
      <VDataGridColumnV2
          id="id"
          width="100px"
          content-align="left"
      >
        <template #label>
          <div>№</div>
        </template>
        <template #default="{ row }">
          <VLink class="nowrap">
            {{ Utils.string.formatWithDelimiter(row.id) }}
          </VLink>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
          id="code"
          label="Артикул"
          width="120px"
          content-align="center"
          filterable
          :filter-props="{
            placeholder: 'Введите артикул',
            clearable:   true,
          }"
      >
        <template #default="{ row }">
          {{ row.code || '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="name"
        label="Название"
        content-class="ellipsis"
        filterable
        filter-send-name="pattern"
        :filter-props="{
          placeholder: 'Введите наименование продукта',
          clearable:   true,
        }"
      >
        <template #default="{ row }">
          <span class="ellipsis" :title="row.name">{{ row.name || '--' }}</span>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>

    <template #footer>
      <VButton @click="$emit('close')">Закрыть</VButton>
    </template>
  </VDialog>
</template>

<style src="./ProductsPicker.scss" lang="scss" />

<script lang="ts">
import Utils                  from '@/core/utils/Utils';
import DataGridLoader         from '@/lib/components/VDataGridV2/DataGridLoader';
import TransportOrder         from '@/domains/TransportOrders/TransportOrder';
import TransportOrderPosition from '@/domains/TransportOrders/TransportOrderPosition';
import ProductsService        from "@/domains/Products/ProductsService";

export default defineComponent({
  name: 'ProductsPicker',

  props: {
    transportOrder: {
      type:     TransportOrder,
      required: true,
    },
  },

  emits: ['close'],

  data() {
    return {
      Utils,

      dataLoader: new DataGridLoader(ProductsService.getListPaginatedForRegistry),
    };
  },

  computed: {
    selectedDocuments(): any[] {
      return this.transportOrder.positions.map(p => p.document);
    },
  },

  methods: {
    async addDocument(product: any): Promise<void> {
      const fullProduct = await ProductsService.get(product.id);
      if (!fullProduct) return;

      const position = TransportOrderPosition.fromProduct(fullProduct, null, null);
      this.transportOrder.addPosition(position);
    },

    removeDocument(product: any): void {
      const position = this.transportOrder.positions.find(
          p => p.documentClass === 'Product' && p.document?.id === product.id,
      );
      if (!position) return;

      this.transportOrder.deletePosition(position);
    },
  },
});
</script>
